import { en } from './translations/en';
import { sv } from './translations/sv';

export const resources = {
  en,
  sv,
};
